module.exports = __webpack_public_path__ + "img/lucky-draw-bg1.1a18d0d4.png";